import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import * as _ from 'lodash';

@Component({
  selector: 'gf-textview',
  template: require('./gf-textview.component.html')
})
export class TextviewComponent implements OnChanges {
  @Input() data: any;
  useMedia: boolean = false;
  usePanel: boolean = true;
  glyphClass: string = '';
  isHtml: boolean = false;
  isMarkdown: boolean = false;
  isPlainText: boolean = true;
  contentHtml: string = '';
  /**
   * Raw source handed to `gf-markdown-viewer` when the content is Markdown.
   * The viewer renders Markdown *and* passes legacy HTML through untouched,
   * which matters for fields that hold a mix of both while stored content
   * migrates over (tracker instructions, SCM access/browse text).
   */
  markdownSource: string = '';

  constructor() {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.data) {
      this.useMedia = _.get(this.data, 'layout', '') == 'media';
      this.usePanel = !this.useMedia;
      this.glyphClass = _.get(this.data, 'glyph', 'glyphicon-text-background');

      this.isHtml = this.checkIsHtml();
      this.isMarkdown = this.checkIsMarkdown();
      this.isPlainText = this.checkIsPlainText();
      this.markdownSource = this.isMarkdown ? _.get(this.data, 'content', '') : '';
      this.contentHtml = this.isMarkdown ? '' : this.getContentHtml();
    }
  }

  private getType(): string {
    return _.get(this.data, 'type', '').toLowerCase();
  }

  private checkIsPlainText(): boolean {
    return !this.isHtml && !this.isMarkdown;
  }

  private checkIsHtml(): boolean {
    return ['htm', 'html', 'html5'].indexOf(this.getType()) > -1;
  }

  private checkIsMarkdown(): boolean {
    return ['md', 'markdown'].indexOf(this.getType()) > -1;
  }

  private getContentHtml(): string {
    const content = this.data?.content;
    if (this.isHtml) {
      return content;
    }

    let breakTag: string = '<br ' + '/>';
      return (content + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
  }
}
